import { createSuspenseComponent, getLazyComponent } from "common/helpers";

export const LineChart = createSuspenseComponent(getLazyComponent(() => import("./LineChart"), "LineChart"));
export const PieChart = createSuspenseComponent(getLazyComponent(() => import("./PieChart"), "PieChart"));
